
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import jwtInterceptor from "../Shared/jwtInterceptor";
// import axios from "axios";
import store from "../../store/index";
function buildPreviousRoute(route) {
  return {
    name: route && route.name ? route.name : null,
    path: route && route.path ? route.path : null,
    fullPath: route && route.fullPath ? route.fullPath : null,
    params: route && route.params ? route.params : {},
    query: route && route.query ? route.query : {}
  };
}

let previousRouteSnapshot = buildPreviousRoute(null);
export default {
  name: "viewTemplate",
  props: {
    isPatientVisit: {
      type: [Boolean, String],
      default: false
    },
    template: String,
    study: String,
    visitid: String,
    // scheduledvisit: { 
    //   type: Object,
    //   default: () => ({})
    // }
  },
  data() {
    return {
      envvar: process.env.NODE_ENV,
      localScheduledVisit: {},
      templateId: "",
      stdyid: "",
      visitids: "",
      saveactive: true,
      ispatientvalue: false,
      previousRoute: buildPreviousRoute(previousRouteSnapshot),
      handledPreviousRouteName: null,
      extraData: null,
      isLoaded: false,
    };
  },
 beforeRouteEnter(to, from, next) {
  console.log("FROM =", from);
  console.log("FROM NAME =", from.name);

  const previousRoute = buildPreviousRoute(from);
  previousRouteSnapshot = previousRoute;

  next(vm => {
    vm.setPreviousRoute(previousRoute);
  });
},
  beforeRouteLeave(to, from, next) {
    if (to.fullPath != "/submitForm") {
      store.dispatch("setopentreeforsubmitForm", false);
    }
    if (to.fullPath != "/subject_schedule") {
      store.dispatch("setopentreeforsubjectschedule", false);
    }
    if (to.fullPath != "/eproSubjects") {
      store.dispatch("setopentreeforeprosubjects", false);
    }
    next()
  },
  mounted() {
    this.openTreeForPreviousRoute(this.previousRoute);
    console.log(this.previousRoute);
  },
  async beforeMount() {
    await this.setTempId();

    if (this.$route.query.tempObj) {
      const decoded = JSON.parse(decodeURIComponent(this.$route.query.tempObj));
      this.extraData = decoded;

      const visitDetails = localStorage.getItem("visitDetails");
      this.localScheduledVisit = JSON.parse(visitDetails);

      // this.isLoaded = true;   // <-- important
      console.log('localScheduledVisit is ', this.localScheduledVisit);
    }
  },

  methods: {
    setPreviousRoute(previousRoute) {
      this.previousRoute = buildPreviousRoute(previousRoute);
      this.openTreeForPreviousRoute(this.previousRoute);
    },
    openTreeForPreviousRoute(previousRoute) {

      const previousRouteName =
        previousRoute && previousRoute.name
          ? previousRoute.name
          : null;
      if (!previousRouteName ||
        this.handledPreviousRouteName == previousRouteName) {
        return;
      }

      this.handledPreviousRouteName = previousRouteName;

      if (previousRouteName == "submitForm") {
        store.dispatch("setopentreeforsubmitForm", true);
      }

      if (previousRouteName == "subject_schedule") {
        store.dispatch("setopentreeforsubjectschedule", true);
      }

      if (previousRouteName == "eproSubjects") {
        store.dispatch("setopentreeforeprosubjects", true);
      }
    },
    normalizeRouteParam(value) {
      if (value == null) {
        return "";
      }

      const normalizedValue = String(value).trim();
      return normalizedValue == "null" || normalizedValue == "undefined"
        ? ""
        : normalizedValue;
    },
    normalizeBooleanParam(value) {
      if (value === true || value === false) {
        return value;
      }

      return String(value).trim().toLowerCase() == "true";
    },
    async setTempId() {
      this.templateId = this.normalizeRouteParam(this.template);
      this.stdyid = this.normalizeRouteParam(this.study);
      this.visitids = this.normalizeRouteParam(this.visitid);
      this.ispatientvalue = this.normalizeBooleanParam(this.isPatientVisit)
    },
    onclosed() {
      // this.$router.push(`/visitforms`);
      this.$router.go(-1);
    }

  },
};
